import PendingPerformInvoiceModal from "../../../parts/modals/pending-perform-invoice";
import AccessRequests from "./AccessRequests";

export const getRoot = async ({ req, res, locals, load }) => {
  const { modal = {} } = req.query;
  const { activeUserToRequest } = locals;

  // Get pending clients from the org owner's performClients array.
  // activeUserToRequest resolves to the org owner for subcoaches/admins.
  const pendingClients = (activeUserToRequest.performClients || []).filter(
    (client) => client.status === "pending"
  );

  if (modal.type === "pending-perform-invoice") {
    await load("pendingPerformInvoices");
  }

  locals.modal = {
    "pending-perform-invoice": <PendingPerformInvoiceModal />,
  }[modal.type];

  res.body = <AccessRequests pendingClients={pendingClients} />;
};

export const postApprove = async ({ res, req, flash, api }) => {
  const { clientId, type } = req.body;

  try {
    const result = await (
      await api("perform-approve-member", {
        method: "POST",
        body: { clientId, type },
      })
    ).json();

    if (result.success) {
      const label = type === "pull" ? "PULL (1:1)" : "PERFORM";
      flash("success", `Member approved as ${label} client`);
    } else {
      throw new Error(result.error || "Failed to approve member");
    }
  } catch (e) {
    console.error("Error approving member:", e);
    flash("error", e.message || "Failed to approve member");
  }

  res.refreshWith({}, { url: "/coaching-portal/access-requests", hash: "#_" });
};

export const postReject = async ({ res, req, flash, api }) => {
  const { clientId } = req.body;

  try {
    const result = await (
      await api("perform-reject-member", {
        method: "POST",
        body: { clientId },
      })
    ).json();

    if (result.success) {
      flash("success", "Member rejected");
    } else {
      throw new Error(result.error || "Failed to reject member");
    }
  } catch (e) {
    console.error("Error rejecting member:", e);
    flash("error", e.message || "Failed to reject member");
  }

  res.refreshWith({}, { url: "/coaching-portal/access-requests", hash: "#_" });
};

export const postBulkApprove = async ({ res, req, flash, api }) => {
  const { clientIds } = req.body;

  try {
    const result = await (
      await api("perform-bulk-approve-members", {
        method: "POST",
        body: { clientIds },
      })
    ).json();

    if (result.success) {
      flash("success", "Members approved");
    } else {
      throw new Error(result.error || "Failed to approve members");
    }
  } catch (e) {
    console.error("Error approving members:", e);
    flash("error", e.message || "Failed to approve members");
  }

  res.refreshWith({}, { url: "/coaching-portal/access-requests", hash: "#_" });
};

export const postEditEmail = async ({ res, req, flash, api }) => {
  const { clientId, newEmail } = req.body;

  try {
    const result = await (
      await api("perform-edit-member-email", {
        method: "POST",
        body: { clientId, newEmail },
      })
    ).json();

    if (result.success) {
      flash("success", "Member email updated successfully");
    } else {
      throw new Error(result.error || "Failed to update email");
    }
  } catch (e) {
    console.error("Error updating email:", e);
    flash("error", e.message || "Failed to update email");
  }

  res.refreshWith({}, { url: "/coaching-portal/access-requests", hash: "#_" });
};
